import React from 'react';
import './tourPromptModal.css';

interface Props {
  isOpen: boolean;
  onYes: () => void;
  onNo: () => void;
}

const TUTORIAL_URL = 'https://www.youtube.com/@tapybl/playlists';

const TourPromptModal: React.FC<Props> = ({isOpen, onYes, onNo}) => {
  if (!isOpen) return null;

  return (
    <div className="TourPromptOverlay">
      <div className="TourPromptContainer">
        <h3>Welcome to your new workspace!</h3>
        <p>Would you like to take a quick tour?</p>
        <a
          href={TUTORIAL_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="TourPromptLink">
          Take a tutorial on &quot;How to use tapybl&quot;
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false">
            <path d="M7 17 17 7" />
            <path d="M7 7h10v10" />
          </svg>
        </a>
        <div className="TourPromptActions">
          <button className="TourPromptBtn TourPromptBtnNo" onClick={onNo}>
            Skip both for now
          </button>
          <button className="TourPromptBtn TourPromptBtnYes" onClick={onYes}>
            Start tour
          </button>
        </div>
      </div>
    </div>
  );
};

export default TourPromptModal;
